import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, info: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, info) {
    this.setState({ info });
    console.error('App Error Boundary caught:', error, info);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 40, fontFamily: 'system-ui, sans-serif', maxWidth: 900, margin: '40px auto' }}>
          <h2 style={{ color: '#dc2626', marginBottom: 12 }}>Something went wrong</h2>
          <pre style={{ color: 'red', fontSize: 12, whiteSpace: 'pre-wrap', background: '#fef2f2', padding: 16, borderRadius: 8, border: '1px solid #fecaca' }}>
            {this.state.error?.message || String(this.state.error)}
          </pre>
          {this.state.info?.componentStack && (
            <details style={{ marginTop: 16 }}>
              <summary style={{ cursor: 'pointer', color: '#6b7280' }}>Component stack</summary>
              <pre style={{ fontSize: 11, background: '#f9fafb', padding: 12, borderRadius: 6, overflow: 'auto', marginTop: 8 }}>
                {this.state.info.componentStack}
              </pre>
            </details>
          )}
          <button onClick={() => window.location.reload()} style={{ marginTop: 16, padding: '8px 16px', background: '#2563eb', color: 'white', border: 'none', borderRadius: 6, cursor: 'pointer' }}>
            Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
